import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCTS_API
} from '../../../constants/API';
import {
  GET_PRODUCT_ATTRIBUTES_LOADING,
  GET_PRODUCT_ATTRIBUTES
} from '../types';

function getProductAttributes(brand) {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_PRODUCT_ATTRIBUTES_LOADING,
      loadingProductAttributes: true
    });
    try {
      const accessToken = await localStorage.getItem('accessToken');
      const { userData } = getState().AuthReducer;

      const productAttributeResponse = await axios.get(
        `${PRODUCTS_API}/attributes/${userData.id}/${brand}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      console.log(productAttributeResponse)
      dispatch({
        type: GET_PRODUCT_ATTRIBUTES,
        loadingProductAttributes: false,
        productAttributes: productAttributeResponse.data
      });
    } catch (e) {
      console.log(e);
      message.error(String(e));
      dispatch({
        type: GET_PRODUCT_ATTRIBUTES_LOADING,
        loadingProductAttributes: false
      });
    }
  };
}
export default getProductAttributes;
